class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.isHovered = false;

    // Add hover event listeners for both details and content
    this.mainDetailsToggle.addEventListener(
      "mouseenter",
      this.onMouseEnter.bind(this)
    );
    this.content.addEventListener("mouseenter", this.onMouseEnter.bind(this));

    this.mainDetailsToggle.addEventListener(
      "mouseleave",
      this.onMouseLeave.bind(this)
    );
    this.content.addEventListener("mouseleave", this.onMouseLeave.bind(this));

    // Prevent default click behavior
    this.mainDetailsToggle
      .querySelector("summary")
      .addEventListener("click", (e) => {
        e.preventDefault();
      });
  }

  closeAllOtherMenus() {
    // Get all header-menu elements
    const allHeaderMenus = document.querySelectorAll("header-menu");
    allHeaderMenus.forEach((menu) => {
      if (menu !== this) {
        menu.close();
      }
    });
  }

  onMouseEnter() {
    this.isHovered = true;
    // Close all other menus first
    this.closeAllOtherMenus();
    // Then open this menu
    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);
    this.onToggle();
  }

  onMouseLeave(event) {
    const relatedTarget = event.relatedTarget;

    // Check if we're moving to the mega menu content
    if (relatedTarget && relatedTarget.closest(".mega-menu__content")) {
      return;
    }

    // Check if we're moving to the header menu area
    if (relatedTarget && relatedTarget.closest(".header__inline-menu")) {
      return;
    }

    // If we're moving above the header menu or to any other area, close the menu
    this.isHovered = false;
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
